<template>
  <div class="display--inline-block" v-if="allowed">
    <button class="button button--small button--light" @click="showModal = !showModal" :disabled="loading">
      <i class="fa fa-spin fa-spinner" v-show="loading"></i>
      <span v-show="!loading">{{ $_('login_history') }}</span>
    </button>
    <span v-if="err" class="form__field"><span class="parsley-error">{{ err }}</span></span>
    <modal v-if="showModal" @close="showModal = false" @submit="exportLeads()" :width="'400px'">
      <h3 slot="header">{{ $_('login_history') }}</h3>
      <div slot="body">
        <p class="push-half--bottom">Please select the date range:</p>
        <date-range-picker v-model="dateRange" :ranges="ranges" :locale-data="dateRangeLocale">
          <template v-slot:input="picker">
            {{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}
          </template>
        </date-range-picker>
      </div>
    </modal>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import Modal from './Modal.vue';
import { downloadCsv } from './utils';

export default {
  components: { DateRangePicker, Modal },
  data () {
    return {
      allowedUsers: [
        'kheys@drmg.ca',
        'kdyson@drmg.ca',
        'kgershbain@drmg.ca',
        'aglinka@drmg.ca',
        'rzhovnirchyk@drmg.ca',
      ],
      user: window.user,
      dateRange: {
        startDate: moment().subtract(1, 'month').toDate(),
        endDate: moment().toDate(),
      },
      ranges: {},
      dateRangeLocale: {
        format: 'yyyy-mm-dd',
        separator: ' - ',
        applyLabel: this.$_('submit'),
        cancelLabel: this.$_('cancel'),
      },
      showModal: false,
      err: '',
      loading: false,
    }
  },
  mounted () {
    this.ranges[this.$_('today')] = [moment().toDate(), moment().toDate()];
    this.ranges[this.$_('yesterday')] = [moment().subtract(1, 'day').toDate(), moment().subtract(1, 'day').toDate()];
    this.ranges[this.$_('last_week')] = [moment().subtract(1, 'week').toDate(), moment().toDate()];
    this.ranges[this.$_('last_month')] = [moment().subtract(1, 'month').toDate(), moment().toDate()];
  },
  watch: {
    dateRange: function(newRange, oldRange) {
      this.exportLeads();
    }
  },
  computed: {
    'allowed': function() {
      return this.user && this.user.email && this.allowedUsers.indexOf(this.user.email) > -1;
    }
  },
  methods: {
    formatDate: function(d) {
      return moment(d).format('YYYY-MM-DD');
    },
    exportLeads: function() {
      let self = this;
      self.showModal = false;
      self.loading = true;
      const date_start = moment(self.dateRange.startDate).format('YYYY-MM-DD');
      const date_end = moment(self.dateRange.endDate).add(1, 'days').format('YYYY-MM-DD');
      self.$http.get(`/admin/users/logins?date_start=${date_start}&date_end=${date_end}`).then(
        function(response) {
          if (response.data) {
            downloadCsv(`user-logins-${date_start}-${date_end}.csv`, response.data)
          }
          self.loading = false;
        },
        function(error) {
          console.error(error);
          self.err = error.response.data;
          self.loading = false;
        }
      )
    },
  }
}
</script>

<style lang="scss">
.daterangepicker {
  border-radius: 0;

  .calendars {
    display: grid;
    grid-template-columns: auto auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/ExportLoginHistory.vue